import { useTranslation } from 'react-i18next';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  cn,
} from '@city-sage/aurum-avis-labs-components';
import { Globe } from 'lucide-react';
import { Button } from '@city-sage/aurum-avis-labs-components';
import { useState } from 'react';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch', comingSoon: true },
  { code: 'fr', name: 'Français', comingSoon: true },
];

interface LanguageSwitchProps {
  variant?: 'default' | 'mobile';
}

export function LanguageSwitch({ variant = 'default' }: LanguageSwitchProps) {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  if (variant === 'mobile') {
    return (
      <>
        <Button variant="ghost" className="w-full justify-start" onClick={() => setIsOpen(true)}>
          <Globe className="mr-2 h-4 w-4" />
          <span>{languages.find(lang => lang.code === i18n.language)?.name || 'Language'}</span>
        </Button>
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Select Language</DialogTitle>
            </DialogHeader>
            <div className="grid gap-2 py-4">
              {languages.map((language) => (
                <Button
                  key={language.code}
                  variant="ghost"
                  className={cn(
                    'w-full justify-start',
                    i18n.language === language.code ? 'bg-accent' : '',
                    language.comingSoon && 'opacity-50 cursor-not-allowed'
                  )}
                  onClick={() => !language.comingSoon && handleLanguageChange(language.code)}
                >
                  <div className="flex items-center justify-between w-full">
                    <span>{language.name}</span>
                    {language.comingSoon && (
                      <span className="text-xs text-muted-foreground ml-2">(coming soon)</span>
                    )}
                  </div>
                </Button>
              ))}
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9">
          <Globe className="h-4 w-4" />
          <span className="sr-only">Switch language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.code}
            onClick={() => !language.comingSoon && handleLanguageChange(language.code)}
            className={cn(
              i18n.language === language.code ? 'bg-accent' : '',
              language.comingSoon && 'opacity-50 cursor-not-allowed'
            )}
          >
            <div className="flex items-center justify-between w-full">
              <span>{language.name}</span>
              {language.comingSoon && (
                <span className="text-xs text-muted-foreground ml-2">(coming soon)</span>
              )}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
} 